import { compareNullableDateStrings } from '@/pages/pipelines/common/modules/board/utils';
import type { PipelineCard, PipelineCardComparator } from '@/pages/pipelines/common/types';

export const compareInvestmentPipelineCardsByLastStageChanged: PipelineCardComparator = (
  left,
  right,
  direction,
) => compareNullableDateStrings(left.lastStageChangedAt, right.lastStageChangedAt, direction);

export const compareInvestmentPipelineCards: PipelineCardComparator = (left, right, direction) =>
  compareByTimerUrgency(left, right) ||
  compareInvestmentPipelineCardsByLastStageChanged(left, right, direction);

const compareByTimerUrgency = (left: PipelineCard, right: PipelineCard) => {
  const leftHasTimer = Boolean(left.timer);
  const rightHasTimer = Boolean(right.timer);

  if (leftHasTimer !== rightHasTimer) return leftHasTimer ? -1 : 1;
  if (!left.timer || !right.timer) return 0;

  const leftExpiry = getTimestamp(left.timer.expiresAt);
  const rightExpiry = getTimestamp(right.timer.expiresAt);

  if (leftExpiry !== null && rightExpiry !== null && leftExpiry !== rightExpiry) {
    return leftExpiry - rightExpiry;
  }

  const toneComparison = getTimerToneRank(left.timer.tone) - getTimerToneRank(right.timer.tone);
  if (toneComparison !== 0) return toneComparison;

  if (leftExpiry !== null && rightExpiry === null) return -1;
  if (leftExpiry === null && rightExpiry !== null) return 1;

  return 0;
};

const getTimerToneRank = (tone: NonNullable<PipelineCard['timer']>['tone']) =>
  ({
    red: 0,
    amber: 1,
    yellow: 2,
    green: 3,
  })[tone];

const getTimestamp = (value?: string | null) => {
  if (!value) return null;
  const timestamp = Date.parse(value);
  return Number.isFinite(timestamp) ? timestamp : null;
};
